// Mock data para grupos de WhatsApp de viajeros

export const destinations = [
  // Asia
  {
    id: 'tailandia',
    name: 'Tailandia',
    region: 'Asia',
    image: 'https://customer-assets.emergentagent.com/job_bc81a99d-52aa-4670-bd05-bad277666170/artifacts/a9yatp3d_IMG_3105.webp',
    whatsappLink: 'https://chat.whatsapp.com/Dn5FpYAzUnM1yFElC7165k',
    popular: true
  },
  {
    id: 'japon',
    name: 'Japón',
    region: 'Asia',
    image: 'https://customer-assets.emergentagent.com/job_bc81a99d-52aa-4670-bd05-bad277666170/artifacts/79oe64c1_IMG_3098.jpeg',
    whatsappLink: 'https://chat.whatsapp.com/FARc7wHkTza6Jqj8cA1Z5b',
    popular: true
  },
  {
    id: 'china',
    name: 'China',
    region: 'Asia',
    image: 'https://images.unsplash.com/photo-1508804185872-d7badad00f7d',
    whatsappLink: 'https://chat.whatsapp.com/K2F5FH5IfKI8EbGgwig8GJ'
  },
  {
    id: 'bali',
    name: 'Indonesia (Bali)',
    region: 'Asia',
    image: 'https://images.unsplash.com/photo-1704253411612-e4deb715dcd8',
    whatsappLink: 'https://chat.whatsapp.com/DAMiB7NLd5CLsiTzd3Xry0',
    popular: true
  },
  {
    id: 'vietnam',
    name: 'Vietnam',
    region: 'Asia',
    image: 'https://customer-assets.emergentagent.com/job_bc81a99d-52aa-4670-bd05-bad277666170/artifacts/l0tteftk_IMG_3106.jpeg',
    whatsappLink: 'https://chat.whatsapp.com/L4M2sUbSVgm64Wa1Fa2d74'
  },
  {
    id: 'emiratos',
    name: 'Emiratos Árabes Unidos',
    region: 'Asia',
    image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c',
    whatsappLink: 'https://chat.whatsapp.com/IRpvexZUKleKPxdvV2XTQa'
  },
  {
    id: 'corea-sur',
    name: 'Corea del Sur',
    region: 'Asia',
    image: 'https://customer-assets.emergentagent.com/job_bc81a99d-52aa-4670-bd05-bad277666170/artifacts/55ggjg12_IMG_3108.jpeg',
    whatsappLink: 'https://chat.whatsapp.com/Hp6MguxMjzIGOZ32qOeGUl'
  },
  {
    id: 'singapur',
    name: 'Singapur',
    region: 'Asia',
    image: 'https://customer-assets.emergentagent.com/job_bc81a99d-52aa-4670-bd05-bad277666170/artifacts/kaju4wxx_IMG_3111.avif',
    whatsappLink: 'https://chat.whatsapp.com/E1Ory9HVOGv84S82m1h8lA'
  },
  {
    id: 'malasia',
    name: 'Malasia',
    region: 'Asia',
    image: 'https://customer-assets.emergentagent.com/job_bc81a99d-52aa-4670-bd05-bad277666170/artifacts/59ah01tt_IMG_3112.jpeg',
    whatsappLink: 'https://chat.whatsapp.com/KBqz4k9SXg28hgN8043tTT'
  },
  {
    id: 'filipinas',
    name: 'Filipinas',
    region: 'Asia',
    image: 'https://customer-assets.emergentagent.com/job_bc81a99d-52aa-4670-bd05-bad277666170/artifacts/lvfx5ezs_IMG_3113.jpeg',
    whatsappLink: 'https://chat.whatsapp.com/D1U7omTNB2v3GSCWP8uJ0C'
  },
  {
    id: 'india',
    name: 'India',
    region: 'Asia',
    image: 'https://customer-assets.emergentagent.com/job_bc81a99d-52aa-4670-bd05-bad277666170/artifacts/mpg0spfv_IMG_3109.jpeg',
    whatsappLink: 'https://chat.whatsapp.com/FX5fofTo8wIHn47dneiEjM'
  },
  {
    id: 'maldivas',
    name: 'Maldivas',
    region: 'Asia',
    image: 'https://customer-assets.emergentagent.com/job_bc81a99d-52aa-4670-bd05-bad277666170/artifacts/1gd3pn3c_IMG_3104.jpeg',
    whatsappLink: 'https://chat.whatsapp.com/EFLv1IUT1C0DkR4zVc2IMq',
    popular: true
  },
  
  // América
  {
    id: 'estados-unidos',
    name: 'Estados Unidos',
    region: 'América',
    image: 'https://customer-assets.emergentagent.com/job_bc81a99d-52aa-4670-bd05-bad277666170/artifacts/dd73lcel_IMG_3110.jpeg',
    whatsappLink: 'https://chat.whatsapp.com/CbWg0f23mTnIH7v8xRXIgf',
    popular: true
  },
  {
    id: 'mexico',
    name: 'México',
    region: 'América',
    image: 'https://images.unsplash.com/photo-1678623848968-df0893b70807',
    whatsappLink: 'https://chat.whatsapp.com/JoPkzDZJaK27qEkWMu7kP3',
    popular: true
  },
  {
    id: 'brasil',
    name: 'Brasil',
    region: 'América',
    image: 'https://customer-assets.emergentagent.com/job_bc81a99d-52aa-4670-bd05-bad277666170/artifacts/r88i9zxc_IMG_3102.jpeg',
    whatsappLink: 'https://chat.whatsapp.com/LG7IUdrPFwj8uSYwpZTR7Y'
  },
  {
    id: 'argentina',
    name: 'Argentina',
    region: 'América',
    image: 'https://customer-assets.emergentagent.com/job_bc81a99d-52aa-4670-bd05-bad277666170/artifacts/cdoucnzc_IMG_3099.jpeg',
    whatsappLink: 'https://chat.whatsapp.com/GWuSzuvgym7DrvC0zwD5wW'
  },
  {
    id: 'colombia',
    name: 'Colombia',
    region: 'América',
    image: 'https://images.unsplash.com/photo-1714686495394-73e2bb1bbd39',
    whatsappLink: 'https://chat.whatsapp.com/DtDVVWOyiKV5nOtClb19VQ'
  },
  {
    id: 'peru',
    name: 'Perú',
    region: 'América',
    image: 'https://images.unsplash.com/photo-1587595431973-160d0d94add1',
    whatsappLink: 'https://chat.whatsapp.com/GkTHIbnSDuG3BomzUDSnTq',
    popular: true
  },
  {
    id: 'costa-rica',
    name: 'Costa Rica',
    region: 'América',
    image: 'https://images.unsplash.com/photo-1682358773739-f3ce164f3f59',
    whatsappLink: 'https://chat.whatsapp.com/JN0LNkl9vt84KBNTJRYqvz'
  },
  {
    id: 'chile',
    name: 'Chile',
    region: 'América',
    image: 'https://customer-assets.emergentagent.com/job_bc81a99d-52aa-4670-bd05-bad277666170/artifacts/8xmeiv0c_IMG_3114.webp',
    whatsappLink: 'https://chat.whatsapp.com/KmzRXewI2RP6sdTzNXqptA'
  },
  {
    id: 'ecuador',
    name: 'Ecuador',
    region: 'América',
    image: 'https://customer-assets.emergentagent.com/job_bc81a99d-52aa-4670-bd05-bad277666170/artifacts/dpohagnu_IMG_3097.jpeg',
    whatsappLink: 'https://chat.whatsapp.com/J0DGvrohtQECUweuE8EZhB'
  },
  {
    id: 'panama',
    name: 'Panamá',
    region: 'América',
    image: 'https://images.unsplash.com/photo-1707485318629-dfd15ab0945f',
    whatsappLink: 'https://chat.whatsapp.com/JSMzAe34SJr7nJL4p4lv15'
  },
  {
    id: 'uruguay',
    name: 'Uruguay',
    region: 'América',
    image: 'https://customer-assets.emergentagent.com/job_bc81a99d-52aa-4670-bd05-bad277666170/artifacts/i1a7up8l_IMG_3103.jpeg',
    whatsappLink: 'https://chat.whatsapp.com/LtrkyiFHC51HYZeUkrGQ2Z'
  },
  
  // Destinos Especiales
  {
    id: 'disneyland-paris',
    name: 'Disneyland París',
    region: 'Especiales',
    image: 'https://customer-assets.emergentagent.com/job_bc81a99d-52aa-4670-bd05-bad277666170/artifacts/tl2s4l7f_IMG_3101.jpeg',
    whatsappLink: 'https://chat.whatsapp.com/KYBEW30CYDWLUZRAoEWg0P',
    special: true
  },
  {
    id: 'orlando',
    name: 'Orlando (Disney & Universal)',
    region: 'Especiales',
    image: 'https://images.unsplash.com/photo-1618945373370-7bde4f8dd9c3',
    whatsappLink: 'https://chat.whatsapp.com/DapU17wV5Iw1MyUFvvn2l6',
    special: true
  },
  
  // Europa
  {
    id: 'francia',
    name: 'Francia',
    region: 'Europa',
    image: 'https://images.unsplash.com/photo-1431274172761-fca41d930114',
    whatsappLink: 'https://chat.whatsapp.com/J1abnikZxfaLWp8Ft0sGDA',
    popular: true
  },
  {
    id: 'espana',
    name: 'España',
    region: 'Europa',
    image: 'https://images.unsplash.com/photo-1543783207-ec64e4d95325',
    whatsappLink: 'https://chat.whatsapp.com/C8VbF40NmmAL1bhIqw21yO',
    popular: true
  },
  {
    id: 'italia',
    name: 'Italia',
    region: 'Europa',
    image: 'https://images.unsplash.com/photo-1552832230-c0197dd311b5',
    whatsappLink: 'https://chat.whatsapp.com/D6ghyFemm6G6iRFJGgD40n',
    popular: true
  },
  {
    id: 'reino-unido',
    name: 'Reino Unido',
    region: 'Europa',
    image: 'https://images.unsplash.com/photo-1513635269975-59663e0ac1ad',
    whatsappLink: 'https://chat.whatsapp.com/EabznvRU9U54BA1gM1NXXU'
  },
  {
    id: 'alemania',
    name: 'Alemania',
    region: 'Europa',
    image: 'https://images.unsplash.com/photo-1467269204594-9661b134dd2b',
    whatsappLink: 'https://chat.whatsapp.com/BSOKdYiG7AE6kV41TxoDGj'
  },
  {
    id: 'turquia',
    name: 'Turquía',
    region: 'Europa',
    image: 'https://images.unsplash.com/photo-1524231757912-21f4fe3a7200',
    whatsappLink: 'https://chat.whatsapp.com/Ejbqc0sbJjy9Gl6cobSQsz'
  },
  {
    id: 'grecia',
    name: 'Grecia',
    region: 'Europa',
    image: 'https://images.unsplash.com/photo-1613395877344-13d4a8e0d49e',
    whatsappLink: 'https://chat.whatsapp.com/FqjivTJVKFq1EBY2u9xRSI',
    popular: true
  },
  {
    id: 'portugal',
    name: 'Portugal',
    region: 'Europa',
    image: 'https://images.unsplash.com/photo-1555881400-74d7acaacd8b',
    whatsappLink: 'https://chat.whatsapp.com/LWkVoQRlLvSIdqdCWlP8OU'
  },
  {
    id: 'paises-bajos',
    name: 'Países Bajos',
    region: 'Europa',
    image: 'https://images.unsplash.com/photo-1534351590666-13e3e96b5017',
    whatsappLink: 'https://chat.whatsapp.com/ISClYgskc91FfuQQ3m9w3F'
  },
  {
    id: 'croacia',
    name: 'Croacia',
    region: 'Europa',
    image: 'https://images.unsplash.com/photo-1516483638261-f4dbaf036963',
    whatsappLink: 'https://chat.whatsapp.com/BEz2gdHldVk6n5xKP18dAk'
  },
  {
    id: 'finlandia',
    name: 'Finlandia',
    region: 'Europa',
    image: 'https://customer-assets.emergentagent.com/job_bc81a99d-52aa-4670-bd05-bad277666170/artifacts/x6d5g60i_IMG_3100.jpeg',
    whatsappLink: 'https://chat.whatsapp.com/LYvUDSlRQN6Ej8V8ye7wQG'
  },
  {
    id: 'islandia',
    name: 'Islandia',
    region: 'Europa',
    image: 'https://images.unsplash.com/photo-1488415032361-b7e238421f1b',
    whatsappLink: 'https://chat.whatsapp.com/FIH57JNDnJX8VRcB1efMnv',
    popular: true
  },
  {
    id: 'noruega',
    name: 'Noruega',
    region: 'Europa',
    image: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b',
    whatsappLink: 'https://chat.whatsapp.com/B66zcpR36Em9hIMoJ2r8yU'
  }
];

export const affiliateLinks = {
  heymondo: {
    name: 'Heymondo',
    discount: '5% de descuento',
    description: 'Seguro de viaje con cobertura mundial',
    url: 'https://heymondo.es/?utm_medium=Afiliado&utm_source=WILDSOULTRAVELLERS&utm_campaign=PRINCIPAL&cod_descuento=WILDSOULTRAVELLERS&ag_campaign=ENTRADA&agencia=mT2gV3F61kWKEGTrVPLp2bqaEYNx3GYJLZoGNOgc',
    code: 'WILDSOULTRAVELLERS'
  },
  iati: {
    name: 'Iati Seguros',
    discount: '5% de descuento',
    description: 'Seguros de viaje especializados',
    url: '#', // Usuario no proporcionó enlace de Iati
    code: ''
  },
  holafly: {
    name: 'Holafly',
    discount: '5% de descuento',
    description: 'eSIM internacional - Internet en cualquier parte del mundo',
    url: 'https://esim.holafly.com/es/?fbclid=PAZnRzaAMecOlleHRuA2FlbQIxMQABpykVqdxsj7WUUAeT8CZ3JcztczIPp9KwkTAvUQ4tz77E-akNkPnpqcLkMJEx_aem_hDt-GcbEH2X04VDdRUFArw&irclickid=TOz0v3TrfxyKW7VzdARYu1Z7UkpzHHUdE0dd2o0&discount=WILDSOULTRAVELLERS&utm_source=affiliate&utm_medium=WILDSOULTRAVELLERS&utm_campaign=5919621&irgwc=1&tw_source=impact&tw_campaign=5919621&tw_term=2006335',
    code: 'WILDSOULTRAVELLERS'
  },
  getyourguide: {
    name: 'GetYourGuide',
    discount: '5% en primera reserva',
    description: 'Tours y actividades en todo el mundo',
    url: 'https://gyg.me/wildsouldtravellers-app',
    code: 'WILDSOULDTRAVELLERS5'
  },
  go12: {
    name: '12go',
    discount: '',
    description: 'Los mejores billetes de transporte por Asia',
    url: 'https://wildsoultravellers.12go.com/es',
    code: ''
  }
};
